export function initRevealPlugin() {
    if (document.querySelector('.js-reveal-trigger')) {
        import('./reveal_animation.js')
            .then(module => module.default())
            .catch(err => console.error(err));
    }
}
